import { render, staticRenderFns } from "./shareSettingDialog.vue?vue&type=template&id=48c53afa&scoped=true"
import script from "./shareSettingDialog.vue?vue&type=script&lang=js"
export * from "./shareSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./shareSettingDialog.vue?vue&type=style&index=0&id=48c53afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c53afa",
  null
  
)

export default component.exports